<template>
  <div>
    <div v-if="! noHeader" class="d-flex align-center" style="min-height: 40px">
      <b>{{ $t('PROJECT_SHEET.ACTIVITY') }}</b>
    </div>
    <v-card :class="{ 'pa-6': ! noHeader }" class="flex-grow-1">
      <div class="d-flex flex-column gap-4 line-height-normal">
        <div v-for="statData in statDataItems" :key="statData.id">
          <div class="d-flex align-center mb-1" :title="`${$t('GLOBAL.TOTAL')} : ${$t(statData.countText, countTextParams(statData.id, stats[statData.id]))}`">
            <v-icon size="small" class="mr-1">{{ statData.icon }}</v-icon> &nbsp;{{ $t(statData.titleText) }}
          </div>
          <div v-if="stats[statData.id].total" class="d-flex align-center">
            <div class="d-flex rounded overflow-hidden flex-grow-1 mr-2" style="height: 18px">
              <div v-for="(stat, id) in stats[statData.id].items" :key="id" :title="userStatTitle(statData.id, stat)"
                   :class="stat.class" :style="{ width: `${stat.percent}%` }" style="height: 18px">
              </div>
            </div>
          </div>
          <div v-else class="text-medium-emphasis small nobr">{{ $t(statData.noneText) }}</div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
  import { buildActionStats, buildBubbleStats, buildWorkloadStats } from '@/components/ProjectSheet/activityHelpers';
  import useUsersAccessRightStore from '@/stores/users/accessRight';

  export default {
    props: {
      planning: { type: Object, required: true },
      noHeader: { type: Boolean, default: false },
    },
    data() {
      return {
        statDataItems: [
          { id: 'actionStats', icon: 'far fa-check-square', titleText: 'PROJECT_SHEET.ACTIONS', countText: 'GLOBAL.ACTIONS_COUNT', noneText: 'PROJECT_SHEET.NO_ACTION' },
          { id: 'workloadStats', icon: 'far fa-weight-hanging', titleText: 'HR.WORKLOAD', countText: 'helpers.workloadCount', noneText: 'PROJECT_SHEET.NO_WORKLOAD' },
          { id: 'bubbleStats', icon: 'fas fa-long-arrow-right', titleText: 'PROJECT_SHEET.PROGRESS', countText: 'GLOBAL.BUBBLES_COUNT', noneText: 'PROJECT_SHEET.NO_BUBBLE' },
        ],
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      stats() {
        return {
          actionStats: buildActionStats(this.planning.elements),
          workloadStats: buildWorkloadStats(this.planning.elements),
          bubbleStats: buildBubbleStats(this.planning.elements),
        };
      },
      workloadInHours() {
        return this.usersAccessRightStore.config.workloadInHours;
      },
    },
    methods: {
      countTextParams(statDataId, stat) {
        if (statDataId == 'workloadStats') {
          return { count: Math.round(stat.total), value: stat.total, workloadInHours: this.workloadInHours };
        }
        return { count: Math.round(stat.total) };
      },
      userStatTitle(statDataId, stat) {
        let unit = '';
        if (statDataId == 'workloadStats') unit = this.$t('helpers.workloadShort', { workloadInHours: this.workloadInHours });
        return `${stat.number}${unit} ${this.$t(stat.label)}`;
      },
    },
  };
</script>
